<script>
	import Settings from '../../../assets/settings.svelte';
	import SettingsPopup from '../Popup/SettingsPopup.svelte';
	export let height;
	export let endRoundonClick = () => {};
	export let endGameonClick = () => {};
	export let onMouseDown = () => {};
	export let showEndRound = true;
</script>

<SettingsPopup {endRoundonClick} {endGameonClick} {showEndRound}>
	<div
		class="setting-btn"
		on:mousedown={onMouseDown}
		style={`height:${height}px;width:${height}px`}
	>
		<Settings />
	</div>
</SettingsPopup>

<style>
	div {
		cursor: pointer;
	}
</style>
